<!-- List of permission types that can be toggled -->
<template>
	<div v-if="userRoles" class="flex w-full flex-col">
		<div
			v-if="userRoles.length === 0"
			class="flex items-center justify-center py-4"
		>
			<p class="text-gray-500">No roles available</p>
		</div>
		<div v-else class="flex w-full flex-col gap-3">
			<ion-item
				v-for="role in userRoles"
				:key="role.id"
				class="rounded-lg transition-colors hover:bg-gray-200"
				color="transparent"
				lines="none"
				button
				:detail="false"
				@click="toggleRoleSelection(role)"
			>
				<ion-checkbox
					slot="start"
					:value="role.id"
					:checked="activeRoles.some((x: number) => x === role.id)"
				/>
				<div class="flex flex-row items-center gap-2">
					<ColorCircle :color="role.color" />
					{{ role.name }}
				</div>
			</ion-item>
		</div>
	</div>
</template>

<script setup lang="ts">
	import { IonCheckbox, IonItem } from "@ionic/vue";
	import { useUserRoles } from "seedgreen-shared/queries/user-role";
	import { UserRoleDTO } from "seedgreen-shared/dtos/UserRoleDTO";
	import ColorCircle from "@/components/ui/ColorCircle.vue";

	defineProps<{
		showInternal?: boolean;
	}>();

	const activeRoles = defineModel<number[]>("activeRoles", {
		required: true,
	});

	const { userRoles } = useUserRoles();

	function toggleRoleSelection(role: UserRoleDTO) {
		const roleId = role.id;
		if (!activeRoles.value) {
			activeRoles.value = [];
		}
		const index = activeRoles.value.indexOf(roleId);

		if (index > -1) {
			activeRoles.value.splice(index, 1);
		} else {
			activeRoles.value.push(roleId);
		}
	}
</script>
